import React from "react";
import { Tag } from "antd";
import { getFormTemplateSelectLabel } from "@/utils/form-template-label";

/**
 * 解析模板归属：优先 API `template_level`（与后端 Form 模型一致），否则按 `company` 是否为空推断
 * （与 {@link filter-forms-by-form-type.js} 的 scopes 约定一致）。
 *
 * @returns {"company"|"system"}
 */
export function resolveFormTemplateScope(row) {
    if (!row || typeof row !== "object") {
        return "system";
    }
    const tl =
        row.template_level != null && String(row.template_level).trim() !== ""
            ? String(row.template_level).trim().toLowerCase()
            : "";
    if (tl === "company") {
        return "company";
    }
    if (tl === "system") {
        return "system";
    }
    const isCompany = row.company != null && String(row.company).trim() !== "";
    return isCompany ? "company" : "system";
}

/**
 * 用于 Select 选项的可搜索纯文本（optionFilterProp / option.label）。
 */
export function formTemplateOptionSearchText(row) {
    if (row === "" || row == null) {
        return "Blank Template(Default) blank default";
    }
    if (typeof row !== "object") {
        return "";
    }
    const title = getFormTemplateSelectLabel(row);
    const isBlank = row.id === "" || row.id === null;
    if (isBlank) {
        return `${title} blank default`;
    }
    const scope = resolveFormTemplateScope(row);
    return `${title} ${scope}`;
}

/**
 * 模板下拉展示：名称 + System / Company 标签（空白模板仅名称）。
 */
export function FormTemplateOptionLabel({ row }) {
    const title = getFormTemplateSelectLabel(row);
    if (row === "" || row == null || typeof row !== "object") {
        return title;
    }
    const isBlank = row.id === "" || row.id === null;
    if (isBlank) {
        return title;
    }
    const scope = resolveFormTemplateScope(row);
    const isCompany = scope === "company";
    return (
        <span className="form-template-option-label">
            <span className="form-template-option-label-text">{title}</span>
            <Tag
                color={isCompany ? "blue" : "default"}
                className="form-template-option-scope-tag"
            >
                {isCompany ? "Company" : "System"}
            </Tag>
        </span>
    );
}
